<template>
    <div class="h-100 d-flex flex-column">
        <v-expansion-panels v-model="activePanel" class="mt-3 px-1" static>
            <v-expansion-panel value="filter">
                <v-expansion-panel-title height="40" :color="activePanel == 'filter' ? 'grey-lighten-3' : 'white'">
                    <p class="font-weight-medium text-secondary">
                        <v-icon class="me-2" color="secondary" icon="icon-filter" size="17"></v-icon>
                        <span class="text-small">فیلتر تاریخچه رویدادها</span>
                    </p>
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                    <div class="d-flex align-center ga-3 mt-2">
                        <datetime-input
                            type="datetime"
                            label="تاریخ"
                            clearable
                            class="flex-1-1-0"
                            v-model="filters.from_date"
                            @update:modelValue="(value) => filters.to_date = value > filters.to_date ? null : filters.to_date"
                        ></datetime-input>
                        <span class="px-3 py-1 mb-8 d-block text-meta text-white bg-secondary rounded">تا</span>
                        <datetime-input
                            :min="filters.from_date"
                            type="datetime"
                            label="تاریخ"
                            clearable
                            class="flex-1-1-0"
                            v-model="filters.to_date"
                        ></datetime-input>
                    </div>
                    <v-select
                        :items="[{ name: 'رویداد داخلی', id: 0 }, { name: 'رویداد خارجی', id: 1 }]"
                        clearable
                        item-title="name"
                        item-value="id"
                        label="بر اساس نوع"
                        no-data-text="موردی پیدا نشد!"
                        v-model="filters.type"
                        @update:modelValue="filters.customer_event_type_ids = null"
                    ></v-select>
                    <v-select
                        :items="$system.customerEventTypes.filter(x => x.type === null || x.type == filters.type)"
                        clearable
                        item-title="name"
                        item-value="id"
                        label="دسته بندی رویداد"
                        no-data-text="موردی پیدا نشد!"
                        multiple
                        v-model="filters.customer_event_type_ids"
                    ></v-select>
                    <div class="d-flex align-center ga-3">
                        <v-btn @click="getCustomerEventList()" color="success" class="flex-grow-1">اعمال فیلتر</v-btn>
                        <v-btn @click="clearFilters" color="secondary" class="rounded" icon="refresh"></v-btn>
                    </div>
                </v-expansion-panel-text>
            </v-expansion-panel>
            <v-expansion-panel value="create">
                <v-expansion-panel-title height="40" :color="activePanel == 'create' ? 'grey-lighten-3' : 'white'">
                    <p class="font-weight-medium text-secondary">
                        <v-icon class="me-2" color="secondary" icon="add"></v-icon>
                        <span class="text-small">ایجاد رویداد</span>
                    </p>
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                    <v-form ref="form" class="mt-2" @submit.prevent="$refs.form?.isValid && submit()">
                        <v-text-field
                            :model-value="user.name"
                            clearable
                            disabled
                            label="* نام و نام خانوادگی"
                        ></v-text-field>
                        <v-select
                            :rules="$validation('required')"
                            :items="$system.customerEventTypes.filter(x => x.type === false)"
                            clearable
                            item-title="name"
                            no-data-text="موردی پیدا نشد!"
                            item-value="id"
                            label="* دسته بندی رویداد"
                            v-model="form.customer_event_type_id"
                        ></v-select>
                        <v-textarea
                            :rules="$validation('required')"
                            label="* توضیحات"
                            no-resize
                            rows="5"
                            v-model="form.description"
                        ></v-textarea>
                        <file-input
                            :style="{backgroundColor: '#e7e7e7', borderRadius: '4px'}"
                            :text="`<p class='text-meta text-center mb-0 py-4'>آپلود فایل‌های پیوست</p>`"
                            :types="$system.systemSettings.attachments_allowed_types"
                            :mimeTypes="$system.systemSettings.attachments_allowed_types.map(x => $system.mimeTypes[x]).flat()"
                            :size="parseInt($system.systemSettings.attachments_maximum_size) * ($system.systemSettings.attachments_maximum_size.indexOf('MB') != -1 ? 1048576 : 1024)"
                            :maxFiles="5"
                            type="file"
                            ref="files"
                        ></file-input>
                        <div class="text-center mt-6">
                            <v-btn type="submit" color="success" class="px-16" :loading="loading">ثبت رویداد</v-btn>
                        </div>
                    </v-form>
                </v-expansion-panel-text>
            </v-expansion-panel>
        </v-expansion-panels>
        <v-infinite-scroll class="flex-grow-1 mt-n2 px-1" :items="customerEvents" @load="getCustomerEventList">
            <v-expansion-panels multiple color="white" static>
                <v-expansion-panel v-for="item in customerEvents">
                    <v-expansion-panel-title class="py-2 px-4 flex-wrap">
                        <div class="d-flex align-center ga-3">
                            <v-avatar v-if="!item.creator" image="@/assets/img/apiEvent.png" class="me-2" size="34"></v-avatar>
                            <v-avatar v-else-if="item.creator.profile_picture_name" :image="item.creator.profile_picture_name" class="me-2" size="34" v-tooltip="item.creator ? item.creator.name : false"></v-avatar>
                            <v-avatar v-else image="@/assets/img/noUser.png" class="me-2" size="34" v-tooltip="item.creator ? item.creator.name : false"></v-avatar>
                            <span class="text-small">{{ $moment(item.created_at).format('HH:mm jYYYY/jMM/jDD') }}</span>
                        </div>
                        <div class="d-flex align-center order-1 w-100 mt-2">
                            <p class="text-small font-weight-bold text-grey-darken-2">{{ item.customer_event_type.name }}</p>
                            <v-spacer></v-spacer>
                            <v-menu :close-on-content-click="false" v-if="item.attachments.length">
                                <template #activator="{ props }">
                                    <v-badge color="error" location="top right" :content="item.attachments.length">
                                        <v-btn size="small" color="secondary" variant="text" icon v-bind="props">
                                            <v-icon icon="icon-attachticket" size="18"></v-icon>
                                        </v-btn>
                                    </v-badge>
                                </template>
                                <v-list>
                                    <v-list-item @click.stop="downloadAttachment([attachment])" link v-for="(attachment,index) in item.attachments">
                                        <v-list-item-title>
                                            <v-icon class="me-1" color="secondary" size="18">file_download</v-icon>
                                            <p class="text-small text-grey-darken-1 d-inline-block">دانلود فایل الحاقی {{index + 1}}</p>
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="downloadAttachment(item.attachments)" link v-if="item.attachments.length > 1">
                                        <v-list-item-title>
                                            <v-icon class="me-1" color="secondary" size="18">view_module</v-icon>
                                            <p class="text-small text-grey-darken-1 d-inline-block">دانلود همه</p>
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                            <v-btn size="small" @click.stop="removeEvent(item.id)" variant="text" icon v-if="$auth.user.full_admin || $auth.user.branch_admin || $auth.user.id == item.creator?.id">
                                <v-icon icon="icon-trash" size="18"></v-icon>
                            </v-btn>
                        </div>
                        <template v-slot:actions="{ expanded }">
                            <v-btn class="px-0" color="secondary" variant="text">
                                جزئیات بیشتر <v-icon class="ms-1" color="secondary" size="24">{{ expanded ? 'arrow_drop_down' : 'arrow_drop_up' }}</v-icon>
                            </v-btn>
                        </template>
                    </v-expansion-panel-title>
                    <v-expansion-panel-text>
                        <p class="text-small mb-n2 text-grey-darken-2" style="white-space: pre-wrap;">{{ item.description }}</p>
                    </v-expansion-panel-text>
                </v-expansion-panel>
            </v-expansion-panels>
            <template v-slot:empty></template>
        </v-infinite-scroll>
    </div>
</template>
<script>
export default {
    data() {
        return {
            activePanel: null,
            page: 1,
            filters: {
                from_date: null,
                to_date: null,
                type: null,
                customer_event_type_ids: null,
            },
            form: {
                customer_event_type_id: null,
                description: null,
            },
            customerEvents: [],
            loading: false,
        };
    },
    props: {
        user: {
            type: Object,
            default: () => ({}),
        },
    },
    methods: {
        clearFilters() {
            for (const key in this.filters)
                this.filters[key] = null;
            this.getCustomerEventList();
        },
        async getCustomerEventList(load = false) {
            if (load === false) {
                this.customerEvents = [];
                this.page = 1;
            }
            let finalFilters = {
                user_id: this.user.id,
                page: this.page++,
                perPage: 10
            };
            for (const key in this.filters)
                if (this.filters[key] !== null && this.filters[key])
                    finalFilters[key] = this.filters[key];
            await this.$customerEventList(finalFilters).then((res) => {
                if (res && res.status == "OK") {
                    this.activePanel = null;
                    this.customerEvents.push(...res.data);
                    if (load !== false)
                        load.done(res.currentPage == res.totalPages ? 'empty' : 'ok');
                }
            });
        },
        removeEvent(id) {
            this.$confirm(`<p class="mb-0 font-weight-medium mt-2">آیا از انجام این عملیات اطمینان دارید؟</p><p class="text-small mb-0 mt-2">در صورت تایید، این رویداد حذف خواهد شد و پس از این در دسترس هیچ فردی نخواهد بود.</p>`).then(async res=>{
                if(res) {
                    this.$customerEventDelete(id).then(res => {
                        if (res && res.status == 'DELETED') {
                            this.$toast.success(res.message);
                            this.getCustomerEventList();
                        }
                    })
                }
            });
        },
        submit() {
            let form = {...this.form, user_id: this.user.id};
            if (this.$refs.files) {
                let attachments = this.$refs.files.getValidFiles();
                if(attachments.length)
                    form.attachments = attachments.map(x => x.file);
            }
            this.loading = true;
            this.$customerEventStore(this.$object.toFormData(form)).then((res) => {
                if (res && res.status == "CREATED") {
                    this.$toast.success(res.message);
                    for (const key in this.form)
                        this.form[key] = null;
                    this.$refs.files.removeAllFiles();
                    this.$refs.form.resetValidation();
                    this.getCustomerEventList();
                }
            }).finally(() => this.loading = false);
        },
        async downloadAttachment(attachments) {
            this.$loading.start();
            await Promise.all(attachments.map(x => this.$downloadAttachment(x.id).then(x => {
                let name = x.headers['content-disposition'].split('filename=')[1].split(';')[0];
                this.$fileDownload(x.data, decodeURIComponent(name));
            })));
            this.$loading.finish();
        },
    },
};
</script>
